import { fontSizes } from '@opallabs/pulsar'
import { colors } from '@opallabs/spectrum'

const inputHeight = 48
const inputWidth = 312

const activeInput = () => ({
  backgroundColor: colors.white.base,
  border: `solid 1px ${colors.n6.base}`,
  color: colors.n3.base,
  fontSize: fontSizes.medium,
  minHeight: inputHeight,
  marginBottom: 8,
  padding: '4px 8px',
  '.public-DraftStyleDefault-block': {
    minHeight: inputHeight,
  },
})

const inactiveInput = () => ({
  backgroundColor: colors.white.base,
  color: colors.n4.base,
  fontSize: fontSizes.small,
  fontWeight: 600,
  padding: '4px 0 0 ',
})

const mentions = {
  marginTop: '-8px',
  width: inputWidth - 10,
}

export const styles = {
  activeInput,
  inactiveInput,
  mentions,
}
